<template>
  <div class="bgHeader">
    <div class="container">
      <b-card
        class="mt-4"
        header="Номин бонус картын онлайн бүртгэл"
        style="padding-bottom: 20px"
      >
        <b-alert
          variant="warning"
          dismissible
          fade
          :show="showDismissibleAlert"
          @dismissed="showDismissibleAlert = false"
        >
          {{ alertMessage }}
        </b-alert>
        <b-form @submit="onSubmit" @reset="onReset" v-if="show">
          <div class="form-row">
            <div class="col-md-6">
              <b-form-group label="Овог:" label-for="lastNameId">
                <b-form-input
                  id="lastNameId"
                  v-model="form.lastName"
                  aria-describedby="input-lastName-feedback"
                  trim
                  :state="ovogState"
                ></b-form-input>
                <b-form-invalid-feedback id="input-lastName-feedback">
                  Овог оруулна уу!
                </b-form-invalid-feedback>
              </b-form-group>
            </div>
            <div class="col-md-6">
              <b-form-group id="firstNameId" label="Нэр:" label-for="input-2">
                <b-form-input
                  id="firstNameId"
                  v-model="form.firstName"
                  type="text"
                  aria-describedby="input-firstName-feedback"
                  trim
                  :state="nerState"
                ></b-form-input>
                <b-form-invalid-feedback id="input-firstName-feedback">
                  Нэр оруулна уу
                </b-form-invalid-feedback>
              </b-form-group>
            </div>
          </div>

          <div class="form-row">
            <div class="col-md-6">
              <b-form-group
                id="registrId"
                label="Регистрийн дугаар:"
                label-for="registrId"
              >
                <div class="form-row">
                  <div class="col-md-2">
                    <b-form-select
                      :options="options"
                      value-field="item"
                      text-field="name"
                      @change="onChangeFirstChar($event)"
                    ></b-form-select>
                  </div>
                  <div class="col-md-2">
                    <b-form-select
                      :options="options"
                      value-field="item"
                      text-field="name"
                      @change="onChangeSecondChar($event)"
                    ></b-form-select>
                  </div>
                  <div class="col-md-8">
                    <b-form-input
                      class="number-width"
                      id="input-12"
                      v-model="registerNumber"
                      type="number"
                      aria-describedby="input-registrNumber-feedback"
                      :state="registerNumberState"
                      trim
                      :formatter="formatRegister"
                    ></b-form-input>
                    <b-form-invalid-feedback id="input-registrNumber-feedback">
                      Регистрийн дугаар оруулна уу
                    </b-form-invalid-feedback>
                  </div>
                </div>
              </b-form-group>
            </div>

            <div class="col-md-6">
              <b-form-group label="И-Мэйл хаяг:" label-for="emailId">
                <b-form-input
                  id="emailId"
                  v-model="form.email"
                  type="email"
                  aria-describedby="input-live-help input-live-feedback"
                  trim
                  :state="emailState"
                ></b-form-input>
                <b-form-text id="input-emailId-help"></b-form-text>
                <b-form-invalid-feedback id="input-emailId-feedback">
                  И-Мэйл оруулна уу
                </b-form-invalid-feedback>
              </b-form-group>
            </div>
          </div>

          <hr />
          <div class="form-row">
            <div class="col-md-12">
              <b-form-group label="Утасны дугаар:" label-for="input-1">
                <div class="form-row">
                  <div class="col-md-6">
                    <div class="form-row">
                      <div class="col-md-8">
                        <b-form-input
                          id="input-12"
                          v-model="form.holderPhone"
                          type="number"
                          aria-describedby="input-live-help input-live-feedback"
                          :state="phoneState"
                          trim
                          :formatter="formatPhone"
                        ></b-form-input>
                        <b-form-text id="input-phone-feedback"></b-form-text>
                        <b-form-invalid-feedback id="input-phone-feedback">
                          Утасны дугаар оруулна уу
                        </b-form-invalid-feedback>
                      </div>

                      <div class="col-md-4">
                        <b-button
                          class="btn-width"
                          variant="success"
                          @click="sendCode"
                          >Код илгээх</b-button
                        >
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6"></div>
                </div>
              </b-form-group>
            </div>
          </div>

          <div class="form-row">
            <div class="col-md-12">
              <b-form-group
                label="Баталгаажуулах код оруулах:"
                label-for="confirmId"
              >
                <div class="form-row">
                  <div class="col-md-6">
                    <div class="form-row">
                      <div class="col-md-8">
                        <b-form-input
                          id="confirmId"
                          v-model="continueCode"
                          type="number"
                          aria-describedby="input-live-help input-live-feedback"
                          :formatter="pinFormat"
                          trim
                        ></b-form-input>
                      </div>
                      <div class="col-md-4">
                        <b-button
                          class="btn-width"
                          variant="success"
                          @click="onClickContinue"
                          >Үргэлжлүүлэх</b-button
                        >
                      </div>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <b-form-text id="input-live-help"></b-form-text>
                    <b-form-invalid-feedback id="input-live-feedback">
                      Утасны дугаар оруулна уу
                    </b-form-invalid-feedback>
                  </div>
                </div>
              </b-form-group>
            </div>
          </div>
          <!-- ---------------------------------------------------------------------------------------------------------------------- -->

          <b-card
            v-if="this.showPin"
            class="mt-4"
            header="Нэвтрэх пин кодоо оруулна уу."
          >
            <div class="form-row">
              <div class="col-md-6">
                <b-form-group label="Пин код оруулах:" label-for="pinCodeId">
                  <b-form-input
                    id="pinCodeId"
                    v-model="form.pinCode"
                    aria-describedby="input-pinCode-feedback"
                    :state="pinCodeState"
                    type="password"
                    :formatter="pinFormat"
                  ></b-form-input>
                  <b-form-invalid-feedback id="input-pinCode-feedback">
                    Пин код оруулна уу
                  </b-form-invalid-feedback>
                </b-form-group>
              </div>
              <div class="col-md-6">
                <b-form-group
                  id="pinCodeConfirmId"
                  label="Пин код давтан оруулах:"
                  label-for="pinCodeConfirmId"
                >
                  <b-form-input
                    id="pinCodeConfirmId"
                    v-model="pinCodeConfirm"
                    type="password"
                    :state="pinCodeConfirmState"
                    :formatter="pinConfirmFormat"
                    aria-describedby="input-pinCodeConfirm-feedback"
                  ></b-form-input>
                  <b-form-invalid-feedback id="input-pinCodeConfirm-feedback">
                    Пин код давтан оруулна уу
                  </b-form-invalid-feedback>
                </b-form-group>
              </div>
            </div>
            <div class="div-btn-left">
              <b-button class="btn-padding" variant="warning" @click="redirect"
                >Цуцлах</b-button
              >
              <b-button class="btn-padding" variant="success" type="submit"
                >Карт үүсгэх</b-button
              >
            </div>
          </b-card>

          <div>
            <Recaptcha
              ref="recap"
              @checkRecaptcha="checkRecaptcha"
              @checkConfirm="checkConfirm"
              @recaptchaError="recaptchaError"
              @sendCodeConfirm="sendCodeConfirm"
            />
          </div>
          <transition name="fade">
            <Success
              :successMessage="successMessage"
              v-if="successModal"
              @hideSuccessMessage="hideSuccessMessage"
            ></Success>
          </transition>
        </b-form>
      </b-card>
    </div>
  </div>
</template>

<script>
import Success from "@/views/plugin/success";
// import Recaptcha from "./VueRecaptcha";
import Recaptcha from "../user/RecapchaUser/VueRecapchaUserRegister.vue";
export default {
  computed: {
    phoneState() {
      return this.form.holderPhone.length >= 8
        ? (this.phoneCheck = true)
        : (this.phoneCheck = false);
    },
    emailState() {
      let validRegex =
        /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
      return this.form.email.match(validRegex)
        ? (this.emailCheck = true)
        : (this.emailCheck = false);
    },

    // ovogState() {
    //   let CorrectOvog = /[А-Яа-яЁёӨөҮүҺһ\s-]/;
    //   return this.form.lastName.match(CorrectOvog)
    //     ? (this.lastNameCheck = true)
    //     : (this.lastNameCheck = false);
    // },

    ovogState() {
      let CorrectOvog = /^[А-ЯҮүӨөЁё\s-]+$/i;
      return CorrectOvog.test(this.form.lastName)
        ? (this.lastNameCheck = true)
        : (this.lastNameCheck = false);
    },

    nerState() {
      let CorrectNer = /^[А-ЯҮүӨөЁё\s-]+$/i;
      return CorrectNer.test(this.form.firstName)
        ? (this.firstNameCheck = true)
        : (this.firstNameCheck = false);
    },

    registerNumberState() {
      return this.registerNumber.length >= 8
        ? (this.registerNumberCheck = true)
        : (this.registerNumberCheck = false);
    },

    validateState() {
      return this.form.bag.length > 0 ? true : false;
    },
    lastNameState() {
      return this.form.lastName.length > 1 ? true : false;
    },
    firstNameState() {
      return this.form.firstName.length > 1 ? true : false;
    },
    pinCodeState() {
      return this.form.pinCode.length >= 4 ? true : false;
    },
    pinCodeConfirmState() {
      return this.form.pinCode.length >= 4 ? true : false;
    },
  },
  name: "CardRegister",
  data() {
    return {
      form: {
        lastName: "",
        firstName: "",
        registerNo: "",
        email: "",
        holderPhone: "",
        pinCode: "",
      },
      registerNumber: "",
      registrFirstChar: "",
      registrSecondChar: "",
      continueCode: "",
      pinCodeConfirm: "",
      phoneCheck: false,
      emailCheck: false,
      lastNameCheck: false,
      firstNameCheck: false,
      registerNumberCheck: false,
      show: true,
      showPin: false,
      showDismissibleAlert: false,
      alertMessage: "",
      successModal: false,
      successMessage: "",
      captchaItem: {
        captchaImage: "",
        captchaToken: "",
        captchaInput: "",
      },
      validateRecaptcha: false,
      errorMessage: "",
      step: 0,
      options: [
        { item: "А", name: "А" },
        { item: "Б", name: "Б" },
        { item: "В", name: "В" },
        { item: "Г", name: "Г" },
        { item: "Д", name: "Д" },
        { item: "Е", name: "Е" },
        { item: "Ё", name: "Ё" },
        { item: "Ж", name: "Ж" },
        { item: "З", name: "З" },
        { item: "И", name: "И" },
        { item: "Й", name: "Й" },
        { item: "К", name: "К" },
        { item: "Л", name: "Л" },
        { item: "М", name: "М" },
        { item: "Н", name: "Н" },
        { item: "О", name: "О" },
        { item: "Ө", name: "Ө" },
        { item: "П", name: "П" },
        { item: "Р", name: "Р" },
        { item: "С", name: "С" },
        { item: "Т", name: "Т" },
        { item: "У", name: "У" },
        { item: "Ү", name: "Ү" },
        { item: "Ф", name: "Ф" },
        { item: "Х", name: "Х" },
        { item: "Ц", name: "Ц" },
        { item: "Ч", name: "Ч" },
        { item: "Ш", name: "Ш" },
        { item: "Щ", name: "Щ" },
        { item: "Ъ", name: "Ъ" },
        { item: "Ы", name: "Ы" },
        { item: "Ь", name: "Ь" },
        { item: "Э", name: "Э" },
        { item: "Ю", name: "Ю" },
        { item: "Я", name: "Я" },
      ],
    };
  },
  methods: {
    sendCode() {
      if (!this.form.lastName) this.showAlert("Овог оруулна уу");
      else if (!this.form.firstName) this.showAlert("Нэр оруулна уу");
      else if (!this.emailCheck) this.showAlert("И-мэйл оруулна уу");
      else if (!this.lastNameCheck)
        this.showAlert("Овог нэрээ зөвхөн крилл үсгээр бичнэ үү");
      else if (!this.firstNameCheck)
        this.showAlert("Овог нэрээ зөвхөн крилл үсгээр бичнэ үү");
      else if (!this.registerNumberCheck)
        this.showAlert("Регистрийн дугаар оруулна уу");
      else if (!this.registrFirstChar)
        this.showAlert("Регистрийн дугаарийн эхний үсэг сонгоно уу");
      else if (!this.registrSecondChar)
        this.showAlert("Регистрийн дугаарийн 2 дахь үсэг сонгоно уу");
      else if (!this.phoneCheck) this.showAlert("Утасны дугаараа оруулна уу");
      else {
        this.form.registerNo =
          this.registrFirstChar + this.registrSecondChar + this.registerNumber;

        let data = {
          tokenId: "TokenDCA29144B44940BC8764D106649",
          holderPhone: this.form.holderPhone,
          type: "phone",
          RegisterNo: this.form.registerNo,
        };
        this.showAlert("Баталгаажуулах код амжилттай илгээгдлээ!!! ");
        this.$refs.recap.sendPinCode(data);
      }
    },
    onClickContinue() {
      if (this.continueCode === "") {
        this.showAlert("Баталгаажуулах код оруулна уу");
      } else {
        let data = {
          tokenId: "TokenDCA29144B44940BC8764D106649",
          secureCode: this.continueCode,
          holderPhone: this.form.holderPhone,
          cardHolderInfId: 0,
        };
        this.$refs.recap.confirmCode(data);
      }
    },

    formatPhone(e) {
      return String(e).substring(0, 8);
    },
    pinFormat(e) {
      return String(e).substring(0, 4);
    },
    pinConfirmFormat(e) {
      return String(e).substring(0, 4);
    },
    formatRegister(e) {
      return String(e).substring(0, 8);
    },
    onSubmit(event) {
      event.preventDefault();

      if (!this.form.lastName) this.showAlert("Овог оруулна уу");
      else if (!this.form.firstName) this.showAlert("Нэр оруулна уу");
      else if (!this.emailCheck) this.showAlert("И-мэйл оруулна уу");
      else if (!this.lastNameCheck)
        this.showAlert("Овог нэрээ зөвхөн крилл үсгээр бичнэ үү");
      else if (!this.firstNameCheck)
        this.showAlert("Овог нэрээ зөвхөн крилл үсгээр бичнэ үү");
      else if (!this.registerNumberCheck)
        this.showAlert("Регистрийн дугаар оруулна уу");
      else if (!this.registrFirstChar)
        this.showAlert("Регистрийн дугаарийн эхний үсэг сонгоно уу");
      else if (!this.registrSecondChar)
        this.showAlert("Регистрийн дугаарийн 2 дохь үсэг сонгоно уу");
      else if (!this.phoneCheck) this.showAlert("Утасны дугаараа оруулна уу");
      else {
        this.form.registerNo =
          this.registrFirstChar + this.registrSecondChar + this.registerNumber;

        if (this.form.pinCode === this.pinCodeConfirm) {
          this.$refs.recap.checkSubmit(this.form);
        } else {
          this.showAlert("Давтан оруулсан пин код буруу байна.");
        }
      }
    },
    onReset(event) {
      event.preventDefault();
      // Reset our form values
      this.form.lastName = "";
      this.form.firstName = "";
      this.registerNumber = null;
      this.lastName = "";
      this.form.email = "";
      this.form.holderPhone = "";
      // Trick to reset/clear native browser form validation state
      this.show = false;
      this.showPin = false;
      this.$nextTick(() => {
        this.show = true;
      });
    },

    showAlert(data) {
      this.showDismissibleAlert = true;
      this.alertMessage = data;
    },
    hideSuccessMessage() {
      (this.successMessage = ""), (this.successModal = false);
      this.$router.push({ name: "login" });
    },
    redirect() {
      this.$router.push("login");
    },

    checkRecaptcha(response) {
      this.showDismissibleAlert = false;
      if (response.data.message === "Амжилттай") {
        this.successMessage = "Амжилттай";
        this.successModal = true;
      } else {
        this.showAlert(response.data.message);
      }
    },
    checkConfirm(response) {
      this.showDismissibleAlert = false;
      if (response.status === 200) {
        this.showPin = true;
      } else {
        this.showAlert(
          "Таны оруулсан утас нь өөр хэрэглэгч дээр бүртгэлтэй байна. Та Картын төвтэй холбогдоно уу! 1800-2888"
        );
      }
    },
    sendCodeConfirm(response) {
      this.showDismissibleAlert = false;
      if (response.status === 200) {
        // this.showPin = true
      } else {
        this.showAlert(response.data.message);
      }
    },
    //change step
    recaptchaError(message) {
      this.showAlert(message);
      this.errorMessage = message;
      this.error = true;
    },

    onChangeFirstChar(event) {
      this.registrFirstChar = event;
    },
    onChangeSecondChar(event) {
      this.registrSecondChar = event;
    },
  },

  validate(success) {
    this.validateRecaptcha = success;
  },

  created() {
    // this.captcha();
  },
  components: {
    Success,
    Recaptcha,
  },
};
</script>

<style>
.btn-width {
  width: 100%;
}

.select-width {
  width: 15%;
}
.number-width {
  width: 70%;
}

.input-code-width {
  width: 50%;
}
.send-code-width {
  width: 30%;
  margin-left: 8px;
}
.div-btn-left {
  float: right;
}
.btn-padding {
  padding-right: 8px;
  margin: 8px;
}
</style>
